import { _get } from "../Api";
import swal from "sweetalert";

const processSettings = (data, callback) => {
  if (data.sp_qr_codes && data.sp_qr_codes[0]) {
    console.log("Setting webapplink");
    localStorage.setItem("webAppLink", data.sp_qr_codes[0].identifier);
  }

  const capitalize = (s) => {
    if (typeof s !== "string") return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
  };
  let generalSettings = {
    description: !!data.show_description,
    allergens: !!data.show_allergens,
    timezone: data.merchant.timezone,
    paymentMethods: [],
  };

  let paymentMethods = JSON.parse(data.payment_methods);

  if (paymentMethods && !Array.isArray(paymentMethods)) {
    paymentMethods = Object.keys(paymentMethods).map((paymentMethod) => {
      return { [paymentMethod]: paymentMethods[paymentMethod] };
    });
  } else if (!paymentMethods) {
    paymentMethods = [];
  }
  let methodNames = [];

  for (let method in paymentMethods) {
    for (let attr in paymentMethods[method]) {
      methodNames.push(attr);
      const newMethod = {
        name: attr,
        delivery: true,
        takeAway: true,
        extraCosts: paymentMethods[method][attr].extra_costs / 100,
      };
      if (paymentMethods[method][attr].delivery !== undefined && paymentMethods[method][attr].delivery !== 1) {
        newMethod.delivery = false;
      }
      if (paymentMethods[method][attr].takeaway !== undefined && paymentMethods[method][attr].takeaway !== 1) {
        newMethod.takeAway = false;
      }
      generalSettings.paymentMethods.push(newMethod);
    }
  }

  // Adding missing payment methods (currently disabled)

  // let difference = wantedMethods.filter(x => !methodNames.includes(x));
  // for(let i in difference) {
  //     generalSettings.paymentMethods.push({name: difference[i], takeaway: false, delivery: false, extraCosts: 0})
  // }

  const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
  const sorter = {
    // "sunday": 0, // << if sunday is first day of week
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7,
  };

  let openingHours = [];
  let counter = 0;
  for (let attribute in data) {
    if (days.includes(attribute)) {
      let obj = JSON.parse(data[attribute]);
      openingHours.push({ name: capitalize(attribute), hours: [] });
      for (let i in obj) {
        let closed = false;
        if (i === "00:00" && obj[i] === "00:00") closed = true;

        openingHours[counter].hours.push({ start: i, end: obj[i], closed });
      }
      counter++;

      openingHours.sort(function sortByDay(a, b) {
        let day1 = a.name.toLowerCase();
        let day2 = b.name.toLowerCase();
        return sorter[day1] - sorter[day2];
      });
    }
  }

  const obj = JSON.parse(data.info);
  let deliveryHours;
  if (obj) {
    deliveryHours = [];
    let counter = 0;
    for (let i in obj.delivery_times) {
      deliveryHours.push({ name: capitalize(i), hours: [] });
      for (let j in obj.delivery_times[i]) {
        let closed = false;
        if (j === "00:00" && obj.delivery_times[i][j] === "00:00") closed = true;

        deliveryHours[counter].hours.push({
          start: j,
          end: obj.delivery_times[i][j],
          closed,
        });
      }
      counter++;
    }

    deliveryHours.sort(function sortByDay(a, b) {
      let day1 = a.name.toLowerCase();
      let day2 = b.name.toLowerCase();
      return sorter[day1] - sorter[day2];
    });
  } else {
    deliveryHours = false;
  }

  const takeAwayDeliverySettings = {
    postCodes: data.ta_postal_codes
      .map((row) => {
        return {
          code: row.postal_code,
          amountWithExtra: row.amount_with_extra_costs,
          extraAmount: row.extra_costs,
          minimumAmount: row.min_amount,
          active: !!row.active,
        };
      })
      .sort((a, b) => a.code - b.code),
    minPickupTime: data.minimum_pickup_minutes || 0,
    numberOfBlocks: data.number_of_blocks || 0,
    minutesPerBlock: data.minutes_per_block || 0,
    asapButton: !!data.asap,
    maxWeightPerBlock: data.max_weight_per_time_block,
  };

  const styling = JSON.parse(data.styling);
  let stylingSettings = {};
  if (styling) {
    stylingSettings = {
      general: {
        iFrame: styling.iframe || false,
        accentColour: styling.accent_color || "",
        backgroundColour: styling.background_color || "",
        textColour: styling.text_color || "",
      },
    };
    if (styling.articles) {
      stylingSettings.articles = {
        border: styling.articles.border || "",
        textColour: styling.articles.text_color || "",
        backgroundColour: styling.articles.background_color || "",
        articleModifierColour: styling.articles.modifierarticle_color || "",
        articleModifierBorder: styling.articles.modifierarticle_border || "",
        articleModifierBackgroundColour: styling.articles.modifierarticle_background_color || "",
        fontWeight: parseInt(styling.articles.font_weight) || 500,
      };
    } else {
      stylingSettings.articles = {
        border: "none",
        textColour: "",
        backgroundColour: "",
        articleModifierColour: "",
        articleModifierBorder: "none",
        articleModifierBackgroundColour: "",
        fontWeight: 500,
      };
    }
    if (styling.articlegroup_tabs) {
      stylingSettings.tabs = {
        textColour: styling.articlegroup_tabs.text_color || "",
        selectedTextColour: styling.articlegroup_tabs.text_color_selected || "",
        fontWeight: parseInt(styling.articlegroup_tabs.font_weight) || 500,
      };
    } else {
      stylingSettings.tabs = {
        textColour: "",
        selectedTextColour: "",
        fontWeight: 500,
      };
    }
  } else {
    stylingSettings = {
      general: {
        iFrame: false,
        accentColour: "",
        backgroundColour: "",
      },
      articles: {
        border: "none",
        textColour: "",
        backgroundColour: "",
        articleModifierColour: "",
        articleModifierBorder: "none",
        articleModifierBackgroundColour: "",
        fontWeight: 500,
      },
      tabs: {
        textColour: "",
        selectedTextColour: "",
        fontWeight: 500,
      },
    };
  }

  callback({
    name: data.merchant.name,
    stylingSettings,
    openingHours,
    deliveryHours,
    generalSettings,
    takeAwayDeliverySettings,
    active: data.active,
    takeawayActive: data.takeaway_active,
    deliveryActive: data.delivery_active,
  });
};

export function getTakeawayDeliverySettings(id, callback) {
  _get("/nova/ta_merchant/" + id)
    .then((result) => {
      console.log("result", result);
      processSettings(result.data, callback);
    })
    .catch((e) => {
      swal({
        title: "Oops!",
        text: "Something went wrong.",
        icon: "error",
      });
      console.log(e);
    });
}
